import {
  processMultiOffersTranslation,
  ProcessMultiOffersTranslation,
} from '@/assets/locales/views/processes/multiOffer/multiOffer.translation.pl.ts';
import {
  processOfferTranslation,
  ProcessOfferTranslation,
} from '@/assets/locales/views/processes/offer/processOffer.translation.pl.ts';

export type ProcessTranslation = {
  multiOffer: ProcessMultiOffersTranslation;
  offer: ProcessOfferTranslation;
};

export const processTranslation: ProcessTranslation = {
  multiOffer: processMultiOffersTranslation,
  offer: processOfferTranslation,
};
